import { Link } from 'react-router-dom';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="relative z-50 flex-shrink-0 bg-transparent py-4 text-center sm:text-left">
            <div className="container-page">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div className="flex items-center gap-6 order-2 sm:order-1">
                        <Link
                            to="/about"
                            className="text-xs font-medium text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors"
                        >
                            About
                        </Link>
                        <Link
                            to="/terms"
                            className="text-xs font-medium text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors"
                        >
                            Terms
                        </Link>
                        <Link
                            to="/privacy"
                            className="text-xs font-medium text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors"
                        >
                            Privacy
                        </Link>
                        <Link
                            to="/cookies"
                            className="text-xs font-medium text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors"
                        >
                            Cookies
                        </Link>
                    </div>

                    <p className="text-[11px] font-medium text-slate-400/70 dark:text-slate-500/70 order-1 sm:order-2">
                        © {currentYear} AuraIcon. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
